/**
 * RailNav — navigation latérale déclarative entre workspaces.
 * Ajouter un mode = une entrée dans WORKSPACES (src/workspaces/index.ts).
 */
import { h, svgIcon } from "../components/dom.js";
import { ICONS } from "../components/icons.js";
import type { WorkspaceContext, WorkspaceDef } from "./types.js";

export class RailNav {
	private readonly nav: HTMLElement;
	private readonly panels = new Map<string, HTMLElement>();
	private readonly ctx: WorkspaceContext;
	private activeId: string | null = null;

	constructor(
		workspaces: WorkspaceDef[],
		private readonly container: HTMLElement,
		ctx: WorkspaceContext
	) {
		this.ctx = ctx;
		this.nav = h("nav", { class: "app-rail", "aria-label": "Espaces de travail" });
		for (const ws of workspaces) {
			const button = h(
				"button",
				{
					class: "rail-item",
					type: "button",
					"data-workspace": ws.id,
					"aria-label": ws.title,
					title: ws.title,
					onclick: () => this.show(ws.id),
				},
				svgIcon(ICONS[ws.icon as keyof typeof ICONS] ?? ICONS.image),
				h("span", { class: "rail-label" }, ws.title)
			);
			this.nav.appendChild(button);

			const panel = h("div", { class: "workspace-panel", "data-panel": ws.id, hidden: true });
			ws.build(panel, ctx);
			this.container.appendChild(panel);
			this.panels.set(ws.id, panel);
		}
	}

	get element(): HTMLElement {
		return this.nav;
	}

	show(id: string): void {
		if (this.activeId === id) return;
		this.activeId = id;
		for (const [wsId, panel] of this.panels) {
			panel.hidden = wsId !== id;
		}
		for (const button of this.nav.querySelectorAll<HTMLButtonElement>(".rail-item")) {
			button.classList.toggle("active", button.dataset.workspace === id);
		}
	}

	showFirst(): void {
		const first = this.nav.querySelector<HTMLButtonElement>(".rail-item");
		if (first?.dataset.workspace) this.show(first.dataset.workspace);
	}
}
